





























































































































import { defineComponent, ref, watch } from '@nuxtjs/composition-api'
import { generateReferenceUrl } from '@/common/utils/product/product'
import { formatDate } from '~/common/utils/dates'
import { CitationImageExtended } from '~/types/product/productTypes'
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'
import IconFa6SolidAngleLeft from '~icons/fa6-solid/angle-left'
import IconFa6SolidAngleRight from '~icons/fa6-solid/angle-right'
import { useModalOverflow } from '~/composables/useModalOverflow'
import { useMobile } from '~/composables/ui/useMobile'

export default defineComponent({
  components: { IconFa6SolidXmark, IconFa6SolidAngleRight, IconFa6SolidAngleLeft },
  props: {
    citationResult: {
      type: Array as () => CitationImageExtended[],
      required: true,
    },
    initialExtendedImage: {
      type: Number,
      required: true,
    },
  },
  emits: ['imgChange', 'modalClose'],
  setup(props, { emit }) {
    if (process.client) {
      // Mount / Unmount overflow
      useModalOverflow()
    }
    const citationImagesCarousel = ref()
    const slickOptions = {
      arrows: false,
      infinite: false,
      initialSlide: props.initialExtendedImage,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
      cssEase: 'linear',
      adaptiveHeight: true,
    }

    const disabledLeft = ref(props.initialExtendedImage <= 0)
    const disabledRight = ref(props.initialExtendedImage >= props.citationResult.length - 1)

    const onArrowClick = (whereTo: string) => {
      if (whereTo === 'next') {
        citationImagesCarousel.value.next()
      } else {
        citationImagesCarousel.value.prev()
      }
    }

    const { isMobile, isTablet } = useMobile()

    const onBeforeChange = (_oldSlideIndex: number, slideIndex: number) => {
      disabledLeft.value = slideIndex <= 0
      disabledRight.value = slideIndex >= props.citationResult.length - 1
      emit('imgChange', slideIndex)
    }

    // .. Wait for change in parent
    watch(
      () => props.initialExtendedImage,
      () => {
        if (citationImagesCarousel.value && citationImagesCarousel.value?.goTo) {
          disabledLeft.value = props.initialExtendedImage <= 0
          disabledRight.value = props.initialExtendedImage >= props.citationResult.length - 1
          citationImagesCarousel.value?.goTo(props.initialExtendedImage)
        }
      }
    )

    return {
      isMobile,
      isTablet,
      slickOptions,
      generateReferenceUrl,
      formatDate,
      onArrowClick,
      citationImagesCarousel,
      disabledLeft,
      disabledRight,
      onBeforeChange,
    }
  },
})
